import { removeElement } from "../../common/array";
import { getFrSize, getPxSize, hasAbsoluteValue, updateOffsetSize, updateSize } from "./utils";
const findItemInParent = (itemToFind) => {
    const itemId = itemToFind.item.id;
    return itemToFind.parentItem.items.findIndex(item => item.id === itemId);
};
export const removeItem = (itemId, itemsInfo) => {
    const itemToRemoveUIModel = itemsInfo.get(itemId);
    if (!itemToRemoveUIModel) {
        return { success: false, renamedItems: [] };
    }
    // TODO: Valid whether the parent is the root node or not. If it is the root, update the fixedSizesSum
    const itemsToRemove = [];
    const itemToRemoveIndex = findItemInParent(itemToRemoveUIModel);
    const parentItem = itemToRemoveUIModel.parentItem;
    const parentItemItems = parentItem.items;
    const itemToAddSpace = parentItemItems[itemToRemoveIndex === 0 ? 1 : itemToRemoveIndex - 1];
    const renamedItems = [];
    // const itemToAddSpaceUIModel = itemsInfo.get(itemToAddSpace.id);
    // Remove the item in a future iteration
    itemsToRemove.push([parentItemItems, itemToRemoveIndex, itemId]);
    // The space reserved for the item can be given to a sibling item
    if (parentItemItems.length > 2) {
        addSpaceToItem(itemToRemoveUIModel, itemsInfo.get(itemToAddSpace.id), itemsInfo);
    }
    // The current group will have one child. Remove the group and and reconnect
    // the child item with the parent of its group
    else if (parentItemItems.length === 2) {
        // TODO: CHECK PARENT ROOT
        const parentItemUIModel = itemsInfo.get(parentItem.id);
        const secondParentItem = parentItemUIModel.parentItem;
        const parentItemIndex = findItemInParent(parentItemUIModel);
        const itemToReplace = secondParentItem.items[parentItemIndex];
        // Push the item rename
        renamedItems.push({ oldId: itemToAddSpace.id, newId: itemToReplace.id });
        // This property is no longer valid in the new parent
        delete itemToReplace.items;
        // Update all properties in the new parent, except for some specific properties
        Object.keys(itemToAddSpace).forEach((key) => {
            if (key !== "id" &&
                key !== "size" &&
                key !== "dragBar" &&
                key !== "fixedOffsetSize") {
                itemToReplace[key] = itemToAddSpace[key];
            }
        });
        itemsInfo.delete(itemToAddSpace.id);
    }
    else {
        // Remove the item and its group parent
    }
    // Delete the item and all its descendants...
    // TODO: Add recursive removal
    itemsToRemove.forEach(itemToRemove => {
        removeElement(itemToRemove[0], itemToRemove[1]);
        itemsInfo.delete(itemToRemove[2]);
    });
    return { success: true, renamedItems: renamedItems };
};
function addSpaceToItem(itemToSubtractUIModel, itemToAddUIModel, itemsInfo) {
    console.log(itemToSubtractUIModel, itemToAddUIModel);
    // TODO: Add implementation. Ensure the given space is relative to 100% (1fr)
    // TODO: Remove drag bar Size from fixedSizesSum
    const itemToSubtractInfo = itemToSubtractUIModel.item;
    const itemToAddInfo = itemToAddUIModel.item;
    // px / px
    if (hasAbsoluteValue(itemToSubtractInfo) && hasAbsoluteValue(itemToAddInfo)) {
        // TODO: FixedSizesSum does not make sense when adding pixels. Update implementation to improve this
        updateSize(itemToAddUIModel, getPxSize(itemToSubtractInfo), 0, "px");
    }
    // px / fr
    else if (hasAbsoluteValue(itemToSubtractInfo)) {
        // TODO: UPDATE FIXED SIZES SUM IN THE PARENT
        // updateSize(startItemUIModel, incrementInPxRTL, fixedSizes, "px");
        // updateOffsetSize(endItemUIModel, -incrementInPxRTL, fixedSizes);
    }
    // fr / px
    else if (hasAbsoluteValue(itemToAddInfo)) {
        // updateOffsetSize(startItemUIModel, incrementInPxRTL, fixedSizes);
        // updateSize(endItemUIModel, -incrementInPxRTL, fixedSizes, "px");
    }
    // fr / fr
    else {
        // TODO: Check if the node is the root
        const fixedSizesSum = itemsInfo.get(itemToSubtractUIModel.parentItem.id).fixedSizesSum;
        // Update fixedOffsetSize if the removed item had
        if (itemToSubtractInfo.fixedOffsetSize != null) {
            updateOffsetSize(itemToSubtractUIModel, itemToSubtractInfo.fixedOffsetSize, fixedSizesSum);
        }
        const newFrSize = getFrSize(itemToSubtractInfo) + getFrSize(itemToAddInfo);
        // TODO: In some situations, this should be avoided (fixedSizesSum). Find a way to remove the use of fixedSizesSum
        updateSize(itemToAddUIModel, newFrSize, fixedSizesSum, "fr");
    }
}
//# sourceMappingURL=remove-item.js.map
